import React from "react";
import { useTranslation } from "locales";
import { ScrollView, View } from "react-native";
import type { ValidationErrorData } from "lib";
import { useThemedStyle, Text } from "@venuepos/react-common";
import type { StyleFunction } from "@venuepos/react-common";

export function ValidationErrorsList({
    errors,
}: {
    errors: { errors: ValidationErrorData[]; rowIndex: number }[];
}) {
    const [t] = useTranslation();
    const styles = useThemedStyle(styleFunc);

    if (errors.length === 0) {
        return null;
    }

    return (
        <ScrollView style={styles.validationErrors}>
            {errors.map((rowError, idx) => (
                <View
                    key={rowError.rowIndex}
                    style={[styles.row, idx % 2 ? styles.oddRow : undefined]}
                >
                    <Text style={styles.validationRowErrorText}>{`${t(
                        "import.invalid_row",
                        {
                            rowIndex: rowError.rowIndex + 1,
                        }
                    )}:`}</Text>
                    {Object.entries(rowError.errors).map(
                        ([validationRule, rule]) => (
                            <Text
                                key={`${rowError.rowIndex}-${validationRule}`}
                                style={styles.validationErrorsText}
                            >
                                {`- ${validationRule}: ${t(
                                    rule.error,
                                    rule.options
                                )}`}
                            </Text>
                        )
                    )}
                </View>
            ))}
        </ScrollView>
    );
}
const styleFunc: StyleFunction = theme => ({
    validationErrors: {
        marginTop: theme.spacingScale,
        maxHeight: 350,
        padding: theme.spacingScale,
        paddingBottom: 0,
        backgroundColor: theme.colors.grey50,
        borderColor: theme.colors.grey100,
        borderWidth: 1,
    },
    validationRowErrorText: {
        ...theme.styles.text,
        fontSize: 16,
        fontWeight: "bold",
    },
    validationErrorsText: {
        ...theme.styles.text,
        marginBottom: theme.spacingScale,
    },
    row: {
        paddingVertical: theme.spacingScale / 2,
        paddingHorizontal: theme.spacingScale,
    },
    oddRow: {
        backgroundColor: theme.colors.grey100,
    },
});
